import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import blogPlaceholder from '../../images/blog-placeholder.svg';
import { Tag } from './tag';
import { Typography } from './typography';
export interface BlogCardProps {
  headline: string;
  tags: string[];
  publishedAt: string;
  readingTime: number;
  link: string;
  language: 'de' | 'en';
  image?: {
    src?: string;
    alt?: string;
    title?: string;
    description?: string;
  };
  intro?: string;
}
export const BlogCard: React.FC<BlogCardProps> = props => {
  const $ = _c(36);
  let t0;
  if ($[0] !== props.publishedAt) {
    t0 = new Date(props.publishedAt).toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
    $[0] = props.publishedAt;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const formattedPublishedAt = t0;
  const t1 = props.link;
  const t2 = `Read the blog post: ${props.headline}`;
  const t3 = props.image?.src ?? blogPlaceholder;
  const t4 = props.image?.alt ?? "Blog Card Image";
  const t5 = props.image?.title ?? "Blog Card Image";
  const t6 = props.image?.description ?? "Blog Card Image";
  let t7;
  if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = <Image src={t3} alt={t4} title={t5} aria-description={t6} width={430} height={322} className="aspect-video w-full rounded-[6px] object-cover" sizes="(min-width: 1680px) 400px, (min-width: 1280px) calc(33.33vw - 40px), (min-width: 1024px) calc(50vw - 30px), (min-width: 768px) calc(50vw - 24px), calc(100vw - 48px)" />;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== props.tags) {
    t8 = props.tags.map(_temp);
    $[7] = props.tags;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <div className="flex flex-wrap gap-2">{t8}</div>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== props.headline) {
    t10 = <Typography variant="P1" weight="bold" lineClamp="inherit">{props.headline}</Typography>;
    $[11] = props.headline;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== props.intro) {
    t11 = <Typography variant="P3" lineClamp="inherit">{props.intro}</Typography>;
    $[13] = props.intro;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <div className="line-clamp-4 flex flex-col gap-2">{t10}{t11}</div>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t7 || $[20] !== t9) {
    t13 = <div className="flex flex-col gap-4">{t7}{t9}{t12}</div>;
    $[18] = t12;
    $[19] = t7;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== formattedPublishedAt) {
    t14 = <Typography variant="tag" weight="bold">{formattedPublishedAt}</Typography>;
    $[22] = formattedPublishedAt;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Typography variant="tag" weight="bold">•</Typography>;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const t16 = props.language === "de" ? "Min. Lesezeit" : "Min. Reading Time";
  let t17;
  if ($[25] !== props.readingTime || $[26] !== t16) {
    t17 = <Typography variant="tag" weight="bold">{props.readingTime}{" "}{t16}</Typography>;
    $[25] = props.readingTime;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t14 || $[29] !== t17) {
    t18 = <div className="mt-6 flex items-center gap-3 l:mt-8">{t14}{t15}{t17}</div>;
    $[28] = t14;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== props.link || $[32] !== t13 || $[33] !== t18 || $[34] !== t2) {
    t19 = <Link href={t1} aria-label={t2} className="ease-in-out relative bottom-0 flex w-full max-w-[480px] cursor-pointer flex-col items-stretch justify-between rounded-lg border border-blue-20 bg-white p-6 transition-[transform] duration-100 l:p-8 l:transition-[bottom] l:duration-250 l:hover:bottom-1">{t13}{t18}</Link>;
    $[31] = props.link;
    $[32] = t13;
    $[33] = t18;
    $[34] = t2;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  return t19;
};
function _temp(tag, idx) {
  return <Tag key={idx} name={tag} />;
}